import React, {Component} from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { connect } from "react-redux";
import 'react-circular-progressbar/dist/styles.css';

class CircularProgressBarStep extends Component {



  render() {
    const totalSteps = this.props && this.props.stepInfo &&  
                       this.props.stepInfo.totalSteps &&  this.props.stepInfo.totalSteps || 15;
    const currentStepNumber = this.props && this.props.stepInfo &&  this.props.stepInfo.stepNumber || 1;
    const fraction = currentStepNumber / totalSteps;
    const percentage = Math.round(100*fraction);
    const color = '#701a82';

    return (
      <div style={{ width: 51, height: 51 }}>
        <CircularProgressbar
          value={percentage}
          text={`${currentStepNumber}/${totalSteps}`}
          styles={buildStyles({
            rotation: 0.5,
            textColor: color,
            pathColor: color,
          })}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
      stepInfo: state.stepInfo,
  };
};

export default connect(mapStateToProps)(CircularProgressBarStep);
